import template from './executivesummary.poc.html';
import controller from './executivesummary.poc.controller';
import './executivesummary.poc.styl';

let executivesummaryPOCComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default executivesummaryPOCComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/executivesummary_poc/executivesummary.poc.component.js